import httpClient from "../http-client/client";

export default class MobileOperatorService {
  //get operator  service
  getOperators = () => {
    return httpClient.get("/operators");
  };
}
